<body>
<app-loader [isLoading]="isLoaded"></app-loader>
<router-outlet></router-outlet>
<div class="hide" *ngIf="!isDesktop">
  <div class="text-center">
    <img src="../assets/images/benefits/benefitslogo.png" alt="">
    <h1>Te recomendamos hacer uso de una pantalla de almenos 1000px...</h1>
    <small>tendras una mejor experiencia </small>
    <p>Att. Hackmonkeys team </p>
  </div>
</div>
</body>
